import { FunctionComponent } from 'react'

import { Props } from './types'
import styles from './RatingBar.styles'

const RatingBar: FunctionComponent<Props> = ({ percentage, size = 'md' }) => (
  <div className={styles({ size }).base()}>
    <span className={styles().fill()} style={{ width: `${percentage}%` }} />
  </div>
)

export default RatingBar
